// ─── Sources d'éléments déclarées par l'app (Core) ────────────────
// Le Core ne connaît pas les collections des modules : l'app lui déclare, en un
// seul endroit, TOUT ce qui compte comme « élément » — calendriers, inventaires,
// plans, budgets… C'est ce qui permet aux jetons d'être un compteur GLOBAL,
// indépendant du type, comme voulu.
//
// Le provider transporte aussi l'ÉTAT du comptage (`pret`, `erreurs`) : sans lui,
// un écran ne peut pas distinguer « tu ne possèdes rien » de « je n'ai pas encore
// fini de compter » — et c'est exactement cette confusion qui laissait créer
// au-delà du quota tant que les listes n'étaient pas revenues.
//
//   <SourcesElementsProvider sources={[{ cle, label, emoji, elements:[…] }]} pret erreurs>
import React, { createContext, useContext, useMemo } from 'react';

const VIDE = { sources: [], pret: true, erreurs: [] };
const Ctx = createContext(VIDE);

export function SourcesElementsProvider({ sources = [], pret = true, erreurs = [], children }) {
  const signature = JSON.stringify(sources.map(s => [s.cle, (s.elements || []).map(e => e.id)]));
  const value = useMemo(
    () => ({ sources, pret, erreurs }),
    [signature, pret, erreurs.join('|')]); // eslint-disable-line react-hooks/exhaustive-deps
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export const useEtatSourcesElements = () => useContext(Ctx) || VIDE;
export const useSourcesElements = () => useEtatSourcesElements().sources || [];

// Nombre d'éléments POSSÉDÉS, tous types confondus : c'est lui que le quota de
// création borne (posséder, pas seulement voir).
export function useNbElementsPossedes() {
  const sources = useSourcesElements();
  return useMemo(
    () => sources.reduce((n, s) => n + (s.elements || []).filter(e => e.proprietaire !== false).length, 0),
    [sources]);
}

export default SourcesElementsProvider;
